export enum DocumentSecurityLevel {
  Folder = 'folder',
  Document = 'document',
}
